import { useNavigate } from "react-router-dom";
import { ArrowLeft, BookOpen, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FINANCIAL_TERMS } from "@/lib/financialTerms";

const FinancialVocabulary = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <header className="sticky top-0 z-50 border-b border-border bg-card/80 backdrop-blur-md">
        <div className="container mx-auto flex max-w-5xl items-center gap-3 px-4 py-4">
          <Button variant="ghost" size="icon" aria-label="Go back" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <div className="min-w-0">
            <h1 className="font-heading text-lg font-bold text-foreground sm:text-xl">Financial Vocabulary</h1>
            <p className="text-xs text-muted-foreground">Quick definitions for the words used throughout your lessons.</p>
          </div>
        </div>
      </header>

      <main className="container mx-auto flex max-w-5xl flex-col gap-6 px-4 py-6">
        <section className="glass-card p-5 sm:p-6">
          <div className="mb-4 flex items-start gap-3">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-primary/20 bg-primary/10">
              <BookOpen className="h-5 w-5 text-primary" />
            </div>
            <div>
              <h2 className="font-heading text-lg font-bold text-foreground">Key Terms Mini-Lesson</h2>
              <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
                This page explains common finance and business words in simple language for ages 13–18, so lessons and quizzes feel easier to follow.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {FINANCIAL_TERMS.map((term) => (
              <div key={term.key} className="rounded-2xl border border-border/60 bg-card/60 p-4">
                <p className="font-heading text-sm font-semibold text-foreground">{term.label}</p>
                <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{term.definition}</p>
              </div>
            ))}
          </div>

          <div className="mt-5 flex flex-col gap-3 rounded-2xl border border-border/60 bg-card/40 p-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="font-heading text-sm font-semibold text-foreground">Keep this open while you learn</p>
              <p className="text-sm text-muted-foreground">You can come back any time if a lesson uses words like APR, ROI, assets, liabilities, or profit.</p>
            </div>
            <Button onClick={() => navigate("/dashboard")} className="gap-2">
              <Sparkles className="h-4 w-4" />
              Back to Dashboard
            </Button>
          </div>
        </section>
      </main>
    </div>
  );
};

export default FinancialVocabulary;
